import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isLogIn } from './Config/Apis';

export const PrivateRoute = () => {
    return isLogIn().isToken ? <Outlet /> : <Navigate to="/login" />;
}
export const PublicRoute = () => {
    return isLogIn().isToken ? <Navigate to="/dashboard" /> : <Outlet />;
}
